<span>
    Your request has been received. If a matching email address exists in our
    system a password reset email will be sent.
</span>
